module.exports = __webpack_public_path__ + "fonts/segoe_ui_bold_italic-webfont.8697930.woff2";